import { ContextModalProps } from '@mantine/modals'
import { UpdateUserForm } from 'components/settings/UpdateUserForm'
import { useUpdateUser } from 'hooks/users'
import { UpdateUser, User } from 'types/users'

type Props = {
  user: User
}

export default function UpdateUserModal({ context, id, innerProps: { user } }: ContextModalProps<Props>) {
  const updateUser = useUpdateUser()

  return (
    <UpdateUserForm
      onSubmit={async (values: UpdateUser) => {
        await updateUser.mutateAsync({ ...values, id: user.id })
      }}
      onCancel={() => context.closeModal(id)}
      initialValues={{
        firstName: user.firstName,
        lastName: user.lastName,
        username: user.username,
        roles: user.roles.map((role) => role.id),
        active: user.active,
        allowedIPs: user.allowedIPs,
      }}
    />
  )
}
